<template>
  <ui-overlay-loader :loading="isLoading">
    <icon name="account-search" v-if="isLoading" class="icon" />
    <div v-if="!isLoading && !sanction">
      Can't show sanction details
    </div>
    <div v-if="isLoaded && sanction">
      <div class="spacer-margin">
        <router-link :to="toAllResults">
          &lsaquo; all results
        </router-link>
      </div>
      <screening-details-section
        :heading="$t(`screening.generalInformation`)"
        :tree="this.sanction.generalInformation"
      />
      <screening-details-section
        :heading="$t(`screening.additionlInformation`)"
        :tree="this.sanction.additionalInformation"
      />
      <screening-details-section
        :heading="$t(`screening.pepInformation`)"
        :tree="this.sanction.pepInformation"
      />
      <screening-details-section
        :heading="$t(`screening.sanctionInformation`)"
        :tree="this.sanction.sanctionInformation"
      />
      <screening-details-section
        :heading="$t(`screening.adverseMedia`)"
        :tree="this.sanction.adverseMedia"
      />
      <screening-details-section
        :heading="$t(`screening.associations`)"
        :tree="this.sanction.associations"
      />
      <ui-card class="spacer-margin">
        <ui-heading no-top-margin>{{ $t(`screening.evidences`) }}</ui-heading>
        <screening-details-child
          v-for="(child, childIndex) in this.sanction.evidences"
          :key="`${childIndex}`"
          :itemValue="child"
        />
      </ui-card>
    </div>
  </ui-overlay-loader>
</template>

<script>
import { mapGetters } from "vuex";
import { getters } from "@/store";
import { SCREENING_STATUS } from "@/constants";
import { ROUTE_NAMES } from "@/router/constants";
import { documentDateFormat } from "@/utils/date";
import { mapActions } from "vuex";
import { actions } from "@/store";
import ScreeningDetailsSection from "@/components/ScreeningDetailsSection";
import ScreeningDetailsChild from "@/components/ScreeningDetailsChild";

export default {
  components: { ScreeningDetailsSection, ScreeningDetailsChild },
  mounted() {
    const { id } = this.$route.params;
    this.searchNaturalEntitiesByResourceId({
      resourceId: id
    });
  },
  computed: {
    ...mapGetters([getters.screeningStatus, getters.screeningDetails]),
    toAllResults() {
      return {
        name: ROUTE_NAMES.SANCTION_SEARCH,
        query: this.$route.query
      };
    },
    isLoaded() {
      return this.screeningStatus === SCREENING_STATUS.LOAD_SUCCESS;
    },
    isLoading() {
      return this.screeningStatus === SCREENING_STATUS.LOADING;
    },
    sanction() {
      return this.screeningDetails;
    },
    fullName() {
      return this.sanction?.generalInformation?.fullName;
    },
    dateOfBirth() {
      return this.sanction?.dateOfBirth;
    },
    sourceNotes() {
      return this.sanction?.sourceNotes;
    },
    types() {
      return this.sanction?.types;
    },
    imageSrc() {
      return this.sanction?.pictures?.[0]?.public_url;
    },
    aka() {
      return this.sanction?.aka?.join(", ");
    },
    associates() {
      return this.sanction?.associates?.join(", ");
    },
    fields() {
      return this.sanction?.fields;
    },
    media() {
      return this.sanction?.media;
    }
  },
  methods: {
    documentDateFormat(date) {
      return documentDateFormat(date);
    },
    hasItems(arr) {
      return arr?.length > 0;
    },
    ...mapActions([actions.searchNaturalEntitiesByResourceId])
  }
};
</script>

<style scoped lang="scss">
.icon {
  display: block;
  width: 50%;
  margin: 0 auto;
  fill: var(--text-color-disabled);
}
.spacer-margin {
  margin: 1rem;
}
</style>
